import { render, staticRenderFns } from "./Tramas.vue?vue&type=template&id=4d92b6a3"
import script from "./Tramas.vue?vue&type=script&lang=js"
export * from "./Tramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports